import React from 'react'
import { useHistory } from 'react-router-dom'

import {
  useList,
  useToggle,
  useRemove
} from '../../../../hooks/admin/unit'

import { LAYOUT_ADMIN_UNIT_NEW } from '../../navigation'

import FullList from '../../../../core/components/listPattern/list'

import {
  WrapperHiddenParameters,
  WrapperUrlParameters
} from '../../../../core/components/listPattern'

import { basicColumns } from './fields'
import Filters from './filters'

const Table = (props) => {
  const { data, isLoading } = useList(props.filters)
  const { mutate: toggle, isLoading: isToggleLoading } = useToggle()
  const { mutate: remove, isLoading: isRemoveLoading } = useRemove()

  const columns = basicColumns({
    ...props,
    actionLoading: isToggleLoading || isRemoveLoading,
    toggle,
    remove,
    loading: isLoading,
    filters: props.filters,
    resize: props.resize,
    hidden: props.hidden
  })

  return (
    <FullList
      columns={columns}
      data={data?.list || []}
      meta={data?.pagination || { current: 1, pageSize: 20, total: 1 }}
      loading={isLoading}
      {...props}
      titulo='UNITS'
      subtitulo='List'
      onPressNew={LAYOUT_ADMIN_UNIT_NEW}
      onSearchByText={(text) => props.onUpdateFilters({ text })}
      resize
    >
      <Filters
        filters={props.filters}
        onUpdateFilters={props.onFilterChangeUpdateUrl}
        {...props}
      />
    </FullList>
  )
}

const MainListView = () => {
  const history = useHistory()
  const defaultValues = { active: 1 }
  const defaultHidden = {} // { "p.description": 1 }

  const onPressBack = () => history.goBack()

  return (
    <WrapperHiddenParameters defaultHidden={defaultHidden}>
      {(hiddenProps) => (
        <WrapperUrlParameters defaultValues={defaultValues}>
          {(urlProps) => (
            <Table
              {...hiddenProps}
              {...urlProps}
              onPressBack={onPressBack}
              defaultValues={defaultValues}
            />
          )}
        </WrapperUrlParameters>
      )}
    </WrapperHiddenParameters>
  )
}

export default MainListView
